import type React from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'

const IconButton = styled.button<{ $selected: boolean; $color: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  padding: ${theme.spacing.sm} ${({ theme }) => theme.spacing.xl};
  border: 2px solid ${({ theme, $selected, $color }) => ($selected ? theme.colors.primary : theme.colors.border)};
  background: ${({ theme, $selected, $color }) => ($selected ? theme.colors.primaryLight : theme.colors.surface)};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.default};
  
  &:hover {
    border-color: ${({ theme, $color }) => theme.colors.border};
    background: ${({ theme, $color }) => theme.colors.surfaceHover};
  }

  &:active {
    border-color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.primaryLight};
  }
  
  .icon {
    width: 20px;
    height: 20px;
    color: ${({ theme, $selected, $color }) => ($selected ? theme.colors.text : theme.colors.textMuted)};
    transition: ${({ theme }) => theme.transitions.default};
  }
  
  .label {
    font-size: ${({ theme }) => theme.typography.xs};
    font-weight: 500;
    color: ${({ theme, $selected }) => ($selected ? theme.colors.text : theme.colors.textMuted)};
    text-transform: capitalize;
    text-align: center;
    line-height: 1.2;
  }
`

interface LargeIconButtonProps {
  selected: boolean
  color: string
  onClick: () => void
  icon: React.ComponentType<{ className?: string }>
  label: string
  type?: 'button' | 'submit' | 'reset'
}

export const LargeIconButton: React.FC<LargeIconButtonProps> = ({
  selected,
  color,
  onClick,
  icon: Icon,
  label,
  type = 'button',
}) => {
  return (
    <IconButton type={type} $selected={selected} $color={color} onClick={onClick}>
      <Icon className="icon" />
      <span className="label">{label}</span>
    </IconButton>
  )
}
